module.exports = __webpack_public_path__ + "static/5-e1aa6456e741a98dd18529a61707d152.png";